module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/iot-data-2015-05-28.paginators.json
// module id = 421
// module chunks = 0